module.exports = __webpack_public_path__ + "img/front-cover.737744e6.png";